import type { SuggestedReview, SuggestionSnapshot } from '../api/reviews';

/**
 * What the Suggested queue had ranked when the reviewer pressed Create review on one of its rows, sent with the create
 * so the server can grade the ENGINE against what people accept (docs/specs/graded-automation.md §1). `engineOrder`
 * must be the list as the server returned it (sorted by priority score), never the on-screen sorted copy.
 */
export function buildSuggestionSnapshot(
  engineOrder: readonly SuggestedReview[],
  chosen: SuggestedReview,
  fetchedAt: number | undefined,
  build: string | null,
): SuggestionSnapshot {
  const index = engineOrder.findIndex((r) => r.bookkeepingId === chosen.bookkeepingId);
  return {
    // 0 is impossible on purpose: the server then records "from the queue, unverifiable" rather than a guessed rank.
    rank: index + 1,
    of: engineOrder.length,
    priorityScore: chosen.priorityScore,
    computedAt: fetchedAt ? new Date(fetchedAt).toISOString() : undefined,
    topIds: engineOrder.slice(0, 10).map((r) => r.bookkeepingId),
    engineBuild: build ?? undefined,
  };
}
